// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.full {
    display: flex;
    flex-direction: column;
}

.integration-icon {
    display: flex;
    margin: 0 auto;
    margin-top: 3%;
    height: 32px;
    width: 32px;
}

.integration-title {
    display: flex;
    justify-content:center;
    margin-top: 10px;
}

.integration-btn {
    height: 33px;
    width: 200px;
    border-radius:5px;
    margin-left:10px;
    background-color:blue;
    color: white;
}

.integration-cb {
    width: 100%;
    height: 100%;
    background-color: white;
}

.integration-cb-div {
    justify-content:center;
    width: 100%;
    margin-top: 12px;
}

.label {
    display:flex;
    justify-content: left;
}

.integration-btn:hover {
    background-color: #007aff;
}

.integration-preview-table {
    width: 100%;
    max-width: 100%;
    margin-top: 20px;
    overflow:scroll;
    justify-content: left;
}

.mockup-class-integration {
    height: 335px;
    width: 821px;
    border: 1px solid black;
    border-radius: 10px;
}
`, "",{"version":3,"sources":["webpack://./src/app/integration/integrationcontrol/integration.control.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,cAAc;IACd,cAAc;IACd,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,iBAAiB;IACjB,gBAAgB;IAChB,qBAAqB;IACrB,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,uBAAuB;AAC3B;;AAEA;IACI,sBAAsB;IACtB,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,qBAAqB;AACzB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,WAAW;IACX,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,YAAY;IACZ,uBAAuB;IACvB,mBAAmB;AACvB","sourcesContent":[".full {\n    display: flex;\n    flex-direction: column;\n}\n\n.integration-icon {\n    display: flex;\n    margin: 0 auto;\n    margin-top: 3%;\n    height: 32px;\n    width: 32px;\n}\n\n.integration-title {\n    display: flex;\n    justify-content:center;\n    margin-top: 10px;\n}\n\n.integration-btn {\n    height: 33px;\n    width: 200px;\n    border-radius:5px;\n    margin-left:10px;\n    background-color:blue;\n    color: white;\n}\n\n.integration-cb {\n    width: 100%;\n    height: 100%;\n    background-color: white;\n}\n\n.integration-cb-div {\n    justify-content:center;\n    width: 100%;\n    margin-top: 12px;\n}\n\n.label {\n    display:flex;\n    justify-content: left;\n}\n\n.integration-btn:hover {\n    background-color: #007aff;\n}\n\n.integration-preview-table {\n    width: 100%;\n    max-width: 100%;\n    margin-top: 20px;\n    overflow:scroll;\n    justify-content: left;\n}\n\n.mockup-class-integration {\n    height: 335px;\n    width: 821px;\n    border: 1px solid black;\n    border-radius: 10px;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
